import React from 'react';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import useTranslate from '~/hooks/useTranslate';
import { pushToGtmLoanAction } from '~/store/actions/gtmActions';
import { useBankInformationFooter } from '../BankInformationFooterContext';
import BackLink from './BackLink';

const BackToVerifiedAccountsLink = () => {
  const dispatch = useAppDispatch();
  const translate = useTranslate();
  const { setShowAddNewAccount } = useBankInformationFooter();

  const onBackToVerifiedAccounts = () => {
    dispatch(
      pushToGtmLoanAction({
        actionName: 'back_to_verified_accounts_pressed',
      })
    );
    setShowAddNewAccount(false);
  };

  return (
    <BackLink
      label={translate('OnboardingOffer.BackToVerifiedAccounts')}
      onClick={onBackToVerifiedAccounts}
    />
  );
};

export default BackToVerifiedAccountsLink;
